import { FunctionalApproval } from '@lendiodevs/lendio-js-utilities/dist/calculator/functional-approval';
import { Approval } from '@lendiodevs/lendio-js-utilities/dist/calculator/types/approval';

const LocApprovalSample = {
  'id': 15851464,
  'name': null,
  'dealId': 5055621,
  'calculationType': 'loc',
  'stability': 'hard',
  'termType': 'months',
  'expires': '2025-01-28 00:00:00',
  'position': 1,
  'netMinimum': 13,
  'pointsTradable': 0,
  'payoffAmount': 0,
  'withheldAmount': 0,
  'notes': '[ApprovalSeeder] This is a test approval',
  'offerLink': 'https://lendersite.example/offers/23138291',
  'hasVariablePayment': null,
  'isTest': 0,
  'publishedToBorrower': null,
  'publishedByLenderUserId': null,
  'created': '2025-01-27 13:44:06',
  'modified': '2025-01-27 13:44:06',
  'deleted': null,
  'options': [
    {
      'id': 65783,
      'approvalId': 15851464,
      'term': 10,
      'paymentFrequency': 'weekly',
      'lenderOptionId': null,
      'periodicRate': 0.5,
      'payments': 44,
      'drawFeePercent': 2.5,
      'daysInPeriod': '7.00000000',
      'periodsPerYear': 52,
      'created': '2025-01-27 13:44:06',
      'modified': '2025-01-27 13:44:06',
      'deleted': null,
      'customCalculatorParams': null,
      'limits': {
        'drawAmount': {
          'min': 5000,
          'max': 35000
        },
        'points': {
          'min': 0,
          'max': 12
        },
        'drawFeeAmount': {
          'min': 0,
          'max': 0
        }
      },
      'createdTimestamp': 1738010646,
      'modifiedTimestamp': 1738010646
    }
  ],
  'loanProductName': 'Business Line of Credit',
  'loanProductRoundingStrategy': 'halfEven',
  'loanProductLenderId': 224,
  'loanProductId': 274,
  'calculatorConfig': {
    'drawFeeAmount': 'DEFAULT',
    'disbursement': 'DEFAULT',
    'annualInterestRate': 'DEFAULT',
    'payback': 'DEFAULT',
    'totalInterest': 'DEFAULT',
    'totalCostOfCapital': 'DEFAULT',
    'apr': 'DEFAULT',
    'centsOnTheDollar': 'DEFAULT',
    'scheduleRowPaymentAmount': 'DEFAULT',
    'scheduleRowInterestAmount': 'DEFAULT',
    'scheduleRowPrincipalAmount': 'DEFAULT',
    'scheduleRowEndBalance': 'DEFAULT',
    'buyRate': 'DEFAULT'
  },
  'benefits': [],
  'loanProductLender': 'On Deck Capital',
  'loanProductType': 'alternative',
  'requestNames': {
    'nonConditional': [
      'Voided Check - voided check needed',
      'Driver\'s License - driver\'s license needed',
      'Valid Phone Number - Valid Phone Number',
      'Alternative Phone Number - Alternative Phone Number',
      'Use of funds',
      'Voided Check - Please upload a voided check from your business bank account.',
      'Driver’s License - Please upload a copy of your driver\'s license.',
      'Proof of Business Address (Recent Business Utility Bill, Current Business License, or Executed Business Lease)',
      'Bank Verification',
      'Tax Return - Business Tax Return document for specified year.'
    ],
    'conditional': []
  },
  'loanProductCategoryType': 'loc'
};

export const LocFunctionalApprovalSample = new FunctionalApproval(LocApprovalSample as unknown as Approval);
